import {createContext} from 'react';

export const TvContext = createContext(null);